import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles, tokens, Text } from '@fluentui/react-components';
import { Heading, Container } from '../../theme/primitives';
import { iconMap } from '../../theme/icons';

const ITEMS = [
  { icon: 'schedule', labelKey: 'shop.advantages.item_0' },
  { icon: 'euro', labelKey: 'shop.advantages.item_1' },
  { icon: 'location_away', labelKey: 'shop.advantages.item_2' },
  { icon: 'verified_user', labelKey: 'shop.advantages.item_3' },
  { icon: 'layers_clear', labelKey: 'shop.advantages.item_4' },
  { icon: 'door_sensor', labelKey: 'shop.advantages.item_5' },
];

const useStyles = makeStyles({
  // paddingTop sumažintas — kartu su CarpenterBanner.jsx apatiniu paddingu
  // (1.5rem) susidarydavo per didelis tuščias tarpas (žr. /admin/bugs
  // "Sumazink si atstuma").
  wrap: {
    paddingLeft: tokens.spacingHorizontalXXL,
    paddingRight: tokens.spacingHorizontalXXL,
    paddingTop: '1rem',
    paddingBottom: '3rem',
    '@media (min-width: 1024px)': { paddingLeft: '3rem', paddingRight: '3rem' },
  },
  title: {
    textAlign: 'center',
    marginBottom: tokens.spacingVerticalXXXL,
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    columnGap: tokens.spacingHorizontalXXL,
    rowGap: tokens.spacingVerticalXXL,
    '@media (min-width: 640px)': { gridTemplateColumns: 'repeat(3, 1fr)' },
  },
  item: { display: 'flex', alignItems: 'center', gap: tokens.spacingHorizontalM },
  icon: { color: tokens.colorBrandForeground2, flexShrink: 0, fontSize: '26px' },
  text: { fontSize: tokens.fontSizeBase300, color: tokens.colorNeutralForeground2 },
});

const Advantages = () => {
  const s = useStyles();
  const { t } = useTranslation();
  return (
    <Container size="xl" className={s.wrap}>
      <Heading as="h2" variant="h3" className={s.title}>{t('shop.advantages.title')}</Heading>
      <div className={s.grid}>
        {ITEMS.map(({ icon, labelKey }) => {
          const Icon = iconMap[icon];
          return (
            <div key={labelKey} className={s.item}>
              {Icon && <Icon className={s.icon} />}
              <Text className={s.text}>{t(labelKey)}</Text>
            </div>
          );
        })}
      </div>
    </Container>
  );
};

export default Advantages;
